import React from "react";

/**
 * 기본 문서/데이터 없음 아이콘
 */
function DefaultIcon() {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            className="h-12 w-12 text-content-muted mb-3"
        >
            <path d="M9 12h6M9 16h6M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" />
            <path d="M13 2v7h7" />
        </svg>
    );
}

/**
 * EmptyState 공통 컴포넌트
 *
 * 데이터가 없을 때 표시하는 빈 상태 UI.
 * 테이블/그리드의 col-span-full 셀에 배치하거나 단독 영역에 사용.
 *
 * Props:
 * - icon: ReactNode (선택, 기본: 문서 아이콘)
 * - title: string (필수)
 * - description: string (선택)
 * - action: { label: string, onClick: function } (선택)
 */
function EmptyState({ icon, title, description, action }) {
    return (
        <div className="col-span-full flex flex-col items-center justify-center py-12">
            {/* 아이콘 영역 */}
            {icon !== undefined ? icon : <DefaultIcon />}

            {/* 제목 */}
            <p className="text-sm font-medium text-content-secondary mt-2">
                {title}
            </p>

            {/* 설명 (선택) */}
            {description && (
                <p className="text-xs text-content-muted mt-1">
                    {description}
                </p>
            )}

            {/* 액션 버튼 (선택) */}
            {action && (
                <button
                    type="button"
                    onClick={action.onClick}
                    className="mt-4 rounded-lg border border-surface-border px-3 py-1.5 text-xs font-medium text-content-secondary hover:bg-surface-hover transition-colors"
                >
                    {action.label}
                </button>
            )}
        </div>
    );
}

export default EmptyState;
